import { TAG_STATUS } from '@evinced-private/ui-common';

import { AccessibilityStatus } from './types';

export const TREND_TAG_KIND = {
	INFO: 'info',
	LIFT: 'lift'
} as const;

export const STATUS_MAPPING = {
	[AccessibilityStatus.POOR]: { status: TAG_STATUS.FAILURE, text: 'Poor' },
	[AccessibilityStatus.MODERATE]: { status: TAG_STATUS.WARNING, text: 'Moderate' },
	[AccessibilityStatus.GOOD]: { status: TAG_STATUS.SUCCESS, text: 'Good' },
	[AccessibilityStatus.EXCELLENT]: { status: TAG_STATUS.SUCCESS, text: 'Excellent' }
} as const;

export const INFO_CONTENT = {
	ACCESSIBILITY_SCORE:
		'The accessibility score reflects the weighted impact of issues across your scanned pages, based on severity and WCAG level. Scores range from 0 to 100 and update daily.',
	UNIQUE_ISSUES: 'Unique issues are single issue types found on one page.',
	UNIQUE_CRITICAL_ISSUES:
		'Unique critical issues are single issue types found on one page and marked as critical.',
	TOTAL_ISSUES: 'Total issues are all issues found across every session and test.',
	TOTAL_CRITICAL_ISSUES:
		'Total critical issues are all critical issues found across every session and test.'
} as const;

export const DISABLED_FEATURE_MESSAGE = 'Contact support to turn on this feature' as const;
